import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 21h18","key":"svg-0"}],["path",{"d":"M7 21v-18","key":"svg-1"}],["path",{"d":"M7 4c5.675 .908 10 5.613 10 11.28a11 11 0 0 1 -1.605 5.72","key":"svg-2"}],["path",{"d":"M5 9h12","key":"svg-3"}],["path",{"d":"M7 13h4","key":"svg-4"}],["path",{"d":"M7 17h4","key":"svg-5"}]]

const IconBuildingBurjAlArab = createReactComponent('outline', 'building-burj-al-arab', 'BuildingBurjAlArab', __iconNode);

export default IconBuildingBurjAlArab;